import { useMutation } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { StockMovementsApiAdapter } from '../adapters/StockMovementsApiAdapter';
import { Service } from '../services/Service';
import { Filters } from '../models/Filters';

// Instancias compartidas
const httpClient = createHttpClient(apiClientWH);
const apiAdapter = new StockMovementsApiAdapter(httpClient);
const service = new Service(apiAdapter);

export const useExportStockMovements = () =>
  useMutation<string, Error, Filters>({
    mutationFn: (filters) => service.exportToExcel(filters),
  });
